<template>
    <div class="chatBox" ref="chatBox" v-show="this.chatAnimation">
        <div class="top">
            <b>欢迎使用跳转代理软件 <i>{{time}}S关闭</i></b>
            <a  @click="handclose">
                <svg class="icon close" aria-hidden="true">
                    <use xlink:href="#icon-cha"></use>
                    <text x="30" y="30" font-size="12"></text>
                </svg>
            </a>
        </div>
        <div class="content">
            <div style="margin-top:10px;">
                <div class="title">
                    <span>
                        立即注册，免费试用<br>
                    </span>
                    <span>
                        工作时间：9:00 - 24:00
                    </span>
                </div>
               <a href="https://www.huashengdaili.com/QQclient/" target="_blank">
                  <svg class="icon qq" aria-hidden="true">
                    <use xlink:href="#icon-social-qq"></use>
                    <text x="30" y="30" font-size="12"></text>
                 </svg>
                 <span style="position:absolute;top:95px;width:20px;color:#35c79f;right:35px;font-size:18px;">联系客服</span>
               </a>
            </div>
            <div class="btn">
                <button @click="handregister">注册</button>
                <button @click="handclose">取消</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
          time: 10
        }
    },
    props:{
        chatAnimation:Boolean
    },
    watch: {
        chatAnimation () {
            if(this.chatAnimation){
                var _this = this
                setTimeout(function(){
                    if(_this.$refs.chatBox.classList) {
                      _this.$refs.chatBox.classList.add("chatBoxAn")
                    }
                },1000)
            }
        }
    },
    mounted () {
      this.computedtime()
    },
    methods:{
        handregister () {
          if(this.$refs.chatBox.classList){
            this.$refs.chatBox.classList.remove("chatBoxAn")
            var _this = this
            setTimeout(function(){
                _this.$router.push('/Register')
                _this.$emit("changeChat",false)
            },1000)
          }
        },
        handclose () {
          console.log(this.$refs.chatBox.classList)
          if(this.$refs.chatBox.classList){
             this.$refs.chatBox.classList.remove("chatBoxAn")
             var _this = this
             setTimeout(function(){
                _this.$emit("changeChat",false)
             },1000)
          }
        },
        computedtime () {
          let time
          time = setInterval(() => {
            if(this.time > 0){
              this.time--
            }else{
              this.time = 0
              clearInterval(time)
              this.handclose()
            }
          },1000)
        }
    }
}
</script>

<style lang="stylus" scoped>
.chatBox
    position fixed
    top 20%
    left 50%
    z-index 999
    padding 18px 16px
    background #fff
    width 400px
    text-align center
    margin-left -200px
    box-shadow 0px 6px 10px #636363
    transition all .36s ease-in-out
    opacity 0
    .top
        border-bottom 1px solid #e0dbdb
        padding-bottom 20px
    .top b
        font-size 20px
    .top b i
      font-size 12px
      color #333
      padding 3px 6px
      border-radius 30px
      margin-left 50px
      color #35c69f
    .top a
        position absolute
        right 16px
        color #333
        cursor pointer
        transition all 1s ease
        transform rotate(0deg)
        &:hover
            transform rotate(360deg)
    .content .title
        display inline-block
        width 256px
        height 100px
        line-height 50px
        position absolute
        left 0
    .content .qq
        margin-left 178px
    .content span
        font-size 16px
        display inline-block
    .content span:nth-child(1)
        font-size 20px
        font-weight bold
        color #35c79f
    .content .btn button
        padding 10px 60px
        margin 0px 10px
        border-radius 2px
        color #585858
        background #fff
        border 1px solid #e2d8d8
        margin 20px 15px 0px 15px
        &:hover
            background #eee
    .content .btn button:nth-child(1)
        background #35c79f
        color #ffffff
        &:hover
            background #2bbd95
.chatBoxAn
    top 40%
    opacity 1
.qq
    width 2.2rem
    height 2.2rem
.close
    width .36rem
    height .36rem
</style>




// WEBPACK FOOTER //
// src/pages/Home/components/chat.vue